import React from 'react';

import {
  Image,
  Accordion,
  AccordionItem,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink, Taxonomy } from '@uncinc/react-drupal-core';

import {
  WysiwygField,
} from '../../../components';

import './style.scss';

const ParagraphObjective = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed'], null);
  const image = entity.getIn(['field_media_image', 0, 'styles', 'ratio_3_2_xxs'], null);
  const uuid = entity.getIn(['uuid', 0, 'value']);
  const linkUri = entity.getIn(['field_link', 0, 'uri'], null);
  const linkTitle = entity.getIn(['field_link', 0, 'title'], null);
  const activities = entity.getIn(['field_activities']);

  return (
    <div className="Paragraph ParagraphObjective">
      <Accordion>
        <AccordionItem
          key={uuid}
          title={(
            <div className="ParagraphObjective__header">
              {image && (
                <div className="ParagraphObjective__header__image">
                  <Image
                    lazyload={false}
                    src={image}
                    alt={entity.getIn(['field_media_image', 0, 'alt'], '')}
                  />
                </div>
              )}
              {title && (
                <div className="ParagraphObjective__header__title">{title}</div>
              )}
              <div className="ParagraphObjective__header__button">
                <i className="icon icon-chevron-right" />
              </div>
            </div>
          )}
          content={(
            <div className="ParagraphObjective__content">
              <div className="ParagraphObjective__content__body">
                {body && (
                  <WysiwygField
                    property="schema:text"
                    html={body}
                  />
                )}
                {activities && (
                  <div className="ParagraphObjective__activities">
                    {activities.map((item) => {
                      const activity = item.get('entity');
                      const activityId = item.get('target_id');
                      return (
                        <Taxonomy
                          id={activityId}
                          entity={activity}
                          viewMode="teaser"
                        />
                      );
                    })}
                  </div>
                )}
                {linkUri && linkTitle && (
                  <CoreLink className="ParagraphObjective__content__link icon-after icon-arrow-right" href={linkUri}>{linkTitle}</CoreLink>
                )}
              </div>
            </div>
          )} />
      </Accordion>
    </div>
  );
};

export default ParagraphObjective;
